@let _title = title();
@let _details = details();

<div class="se-side-details-item_outer-container">
    @if (_title) {
        <div class="se-side-details-item__title-container text-center">
            <span class="se-side-details-item__title">{{ _title | translate }}</span>
        </div>
    }

    <div class="se-side-details-item__container">
        @for (detail of _details; track $index) {
            @if (
                !detail.estensaColDef.hide &&
                !detail.estensaColDef.context.estensaDetails.primary &&
                detail.estensaColDef.headerName
            ) {
                <div>
                    <span
                        #key
                        class="se-side-detail__key"
                        matTooltip="{{ detail.estensaColDef.headerName | translate }}"
                        positionAtOrigin="true"
                        [matTooltipDisabled]="_isTooltipDisabled(key)"
                    >
                        {{ detail.estensaColDef.headerName | translate | uppercase }} :
                    </span>

                    <span
                        #value
                        class="se-side-detail__value"
                        matTooltip="{{ detail.value }}"
                        positionAtOrigin="true"
                        [matTooltipDisabled]="_isTooltipDisabled(value)"
                    >
                        {{ detail.value }}
                    </span>
                </div>
            }
        }
    </div>
</div>
